{
  "toasts": {
    "created": "Template criado com sucesso!",
    "createError": "Erro ao criar template",
    "restored": "Template restaurado para o padrão",
    "restoreError": "Erro ao restaurar o template",
    "updated": "Template atualizado com sucesso!",
    "updateError": "Erro ao atualizar template",
    "saveError": "Erro ao salvar o template"
  },
  "page": {
    "title": "Templates de Email",
    "subtitle": "Configure os emails enviados automaticamente em cada evento da plataforma"
  },
  "categories": {
    "authentication": "Autenticação",
    "enrollments": "Matrículas",
    "progress": "Progresso",
    "payments": "Pagamentos",
    "community": "Comunidade",
    "gamification": "Gamificação",
    "allWithCount": "Todos ({{count}})",
    "withCount": "{{label}} ({{count}})"
  },
  "stats": {
    "mappedEvents": "Eventos mapeados",
    "createdTemplates": "Templates criados",
    "active": "Ativos",
    "inactive": "Inativos"
  },
  "status": {
    "active": "Ativo",
    "inactive": "Inativo",
    "noTemplate": "Sem template",
    "toggleAllLanguages": "Ativa ou desativa o template em todos os idiomas"
  },
  "actions": {
    "edit": "Editar",
    "createTemplate": "Criar Template",
    "cancel": "Cancelar",
    "save": "Salvar"
  },
  "reset": {
    "title": "Redefinir template",
    "description": "O assunto e o conteúdo em {{language}} voltam ao padrão da plataforma. As alterações feitas neste idioma serão perdidas.",
    "confirm": "Redefinir"
  },
  "logo": {
    "alt": "Logo",
    "title": "Logo dos emails",
    "descriptionWithLogo": "Exibida automaticamente no topo de todos os templates.",
    "descriptionEmpty": "Envie uma logo para exibir em todos os emails (PNG, JPG ou SVG, até 2MB).",
    "remove": "Remover",
    "replace": "Substituir",
    "upload": "Enviar logo"
  },
  "editor": {
    "fallbackTitle": "Template",
    "createTitle": "Criar: {{title}}",
    "editTitle": "Editar: {{title}}",
    "subject": "Assunto do email",
    "subjectPlaceholder": "Assunto do email com {{open}}variáveis{{close}}",
    "variables": "Variáveis disponíveis",
    "variablesHint": "(clique para inserir no editor)",
    "preview": "Preview",
    "from": "De:",
    "to": "Para:",
    "subjectLabel": "Assunto:",
    "previewFrameTitle": "Email Preview",
    "newLanguage": "Novo",
    "unsavedChanges": "Alterações não salvas",
    "missingLanguage": "Este idioma ainda não tem template. O conteúdo abaixo é o padrão da plataforma e será criado ao salvar."
  },
  "languages": {
    "label": "Idiomas do template",
    "available": "{{language}}: criado",
    "missing": "{{language}}: ainda não criado"
  },
  "eventCatalog": {
    "first-access": {
      "name": "Usuário Criado",
      "description": "Disparado quando um novo usuário é criado. Envia boas-vindas ou credenciais de primeiro acesso."
    },
    "user-updated": {
      "name": "Usuário Atualizado",
      "description": "Disparado quando dados do perfil do usuário são alterados (ex: email, nome)."
    },
    "password-reset": {
      "name": "Redefinição de Senha",
      "description": "Disparado quando o usuário ou admin solicita redefinição de senha. Envia link para definir nova senha."
    },
    "login-new-device": {
      "name": "Login em Novo Dispositivo",
      "description": "Alerta de segurança disparado quando o usuário faz login em um dispositivo ou navegador novo."
    },
    "enrollment-confirmation": {
      "name": "Matrícula Criada",
      "description": "Disparado quando o usuário é matriculado em um curso (compra, admin manual ou grupo de acesso)."
    },
    "enrollment-removed": {
      "name": "Matrícula Removida",
      "description": "Disparado quando a matrícula de um usuário é cancelada ou expirada."
    },
    "enrollment-expiring": {
      "name": "Matrícula Expirando",
      "description": "Disparado quando faltam poucos dias para a matrícula do aluno expirar. Ideal para renovação."
    },
    "enrollment-expired": {
      "name": "Matrícula Expirada",
      "description": "Disparado quando a matrícula do aluno expirou e o acesso foi removido."
    },
    "lesson-added": {
      "name": "Aula Adicionada",
      "description": "Disparado quando uma nova aula é publicada. Notifica todos os alunos matriculados no curso."
    },
    "lesson-completed": {
      "name": "Aula Concluída",
      "description": "Disparado quando o aluno conclui uma aula. Ideal para parabenizar o progresso."
    },
    "module-completed": {
      "name": "Módulo Concluído",
      "description": "Disparado quando o aluno conclui todas as aulas de um módulo do curso."
    },
    "course-completed": {
      "name": "Curso Concluído",
      "description": "Disparado quando o aluno conclui 100% das aulas de um curso. Momento de celebração!"
    },
    "certificate-issued": {
      "name": "Certificado Emitido",
      "description": "Disparado quando um certificado de conclusão é gerado para o aluno."
    },
    "inactivity-reminder": {
      "name": "Lembrete de Inatividade",
      "description": "Reengajamento — disparado quando o aluno fica sem acessar a plataforma por X dias."
    },
    "payment-confirmed": {
      "name": "Pagamento Aprovado",
      "description": "Disparado quando um pagamento é confirmado. Envia confirmação e acesso ao conteúdo."
    },
    "payment-refunded": {
      "name": "Pagamento Reembolsado",
      "description": "Disparado quando um reembolso é processado. Informa o usuário sobre o estorno."
    },
    "comment-reply": {
      "name": "Resposta a Comentário",
      "description": "Disparado quando alguém responde ao comentário do usuário em uma aula."
    },
    "comment-reaction": {
      "name": "Reação a Comentário",
      "description": "Disparado quando alguém reage ao comentário do usuário (curtida, etc)."
    },
    "comment-mention": {
      "name": "Menção em Comentário",
      "description": "Disparado quando alguém menciona o usuário (@nome) em um comentário ou resposta."
    },
    "points-earned": {
      "name": "Pontos Ganhos",
      "description": "Disparado quando o usuário ganha XP por completar ações. Alta frequência — desativado por padrão."
    },
    "level-up": {
      "name": "Subiu de Nível",
      "description": "Disparado quando o usuário sobe de nível no sistema de gamificação. Momento de comemoração!"
    },
    "badge-earned": {
      "name": "Conquista Desbloqueada",
      "description": "Disparado quando o usuário conquista uma nova insígnia ou troféu na plataforma."
    },
    "weekly-report": {
      "name": "Relatório Semanal",
      "description": "Resumo semanal do progresso do aluno: aulas vistas, XP ganho, posição no ranking."
    }
  }
}
